@if (selectedSection != null) {
    @if (tablesMode == 'Tables') {
        <!-- Tables -->
        <div #toolbox id="toolbox">
            @if (editingTable == null) {
                
                @for (tableCategory of tableCategories; track $index) {
                    <div class="category">
                        
                        @for (tableType of tableCategory.tableTypes; track $index) {
                            <div class="table-container">

                                @for (tableInstance of tableType.instances; track $index) {
                                    <div cdkDrag [cdkDragStartDelay]="100" [cdkDragData]="{ tableCategory, tableType }"
                                        (cdkDragStarted)="dragStarted($event)" (cdkDragMoved)="dragMoved($event)"
                                        (cdkDragEnded)="dragEnded($event)" (mousedown)="tableMouseDown($event, tableType.imageType)" 
                                        (mouseup)="tableMouseUp($event)" class="table-type"
                                        [class.dnd-enabled]="dndEnabled && draggedTableType == tableType.imageType"
                                        [attr.data-image-type]="tableType.imageType">

                                        <!-- table image -->
                                        <img [src]="tableType.imageType | tableImage" [class]="tableType">

                                        <div class="table-info-container">
                                            <span class="covers">{{tableCategory.covers}}</span>
                                        </div>
                                    </div>
                                }

                            </div>
                        }

                    </div>
                }

            } @else {
                <!-- table properties -->
                <div class="table-properties">

                    <!-- table name -->
                    <div class="d-flex flex-column">
                        <label>Table Name</label>
                        <input type="text" class="ihost-control" placeholder="Table Name" name="tablename" autocomplete="tablename"
                            [ngModel]="editingTable.table.tableName" (ngModelChange)="setEditingTableName($event)">
                    </div>

                    <!-- capacity min/max -->
                    <div class="d-flex flex-row justify-content-between align-items-center">
                        <div class="d-flex flex-column w-half">
                            <label>Min</label>
                            <input type="number" class="ihost-control" placeholder="Min" name="mincapacity" autocomplete="mincapacity"
                                [ngModel]="editingTable.table.minCapacity" (ngModelChange)="setEditingTableMinCapacity($event)">
                        </div>
                        <div class="d-flex flex-column w-half">
                            <label>Max</label>
                            <input type="number" class="ihost-control" placeholder="Max" name="maxcapacity" autocomplete="maxcapacity"
                                [ngModel]="editingTable.table.maxCapacity" (ngModelChange)="setEditingTableMaxCapacity($event)">
                        </div>
                    </div>

                    <!-- rotation -->
                    <div class="d-flex flex-column">
                        <label>Rotate</label>
                        <div class="d-flex flex-row justify-content-evenly">
                            <app-icon icon="Rotate90" (click)="setEditingTableRotation(90)"></app-icon>
                            <app-icon icon="Rotate45" (click)="setEditingTableRotation(45)"></app-icon>
                            <app-icon icon="Rotate360" (click)="setEditingTableRotation(360)"></app-icon>
                            <app-icon icon="Rotate315" (click)="setEditingTableRotation(315)"></app-icon>
                        </div>
                    </div>

                    <!-- order -->
                    <div class="d-flex flex-column">
                        <label>Order</label>
                        <input type="number" class="ihost-control" placeholder="Table Order" name="tableorder" autocomplete="tableorder"
                            [ngModel]="editingTable.table.tableOrder" (ngModelChange)="setEditingTableOrder($event)">
                    </div>

                    <!-- buttons -->
                    <div class="d-flex flex-column mt-4">
                        <button id="setBtn" class="btn btn-main btn-sm" type="button" (click)="saveTableProperties()">
                            {{ 'common.buttons.set' | translate }}
                        </button>
                        @if (!editingTable.isNew) {
                            <button id="deleteBtn" class="btn btn-danger btn-sm mt-2" type="button" (click)="deleteTableConfirmationModal.show()">
                                {{ 'common.buttons.delete' | translate }}
                            </button>
                        }
                        <button class="btn btn-remove btn-sm mt-2" type="button" (click)="cancelEditTable()">
                            {{ 'common.buttons.cancel' | translate }}
                        </button>
                    </div>

                </div>
            }
        </div>
    } @else {
        <!-- Joined Tables -->
        <div class="d-flex flex-column h-100 p-2">
            
            <!-- note -->
            <p class="join-tables-note">{{ 'tablesPlan.editMode.joinTablesNote' | translate }}</p>
            
            <div class="position-relative d-flex flex-column h-100">
                <!-- Add Joined Tables -->
                 <div class="d-flex justify-content-between">
                    <span class="d-flex align-items-center">{{ 'tablesPlan.editMode.joinTables' | translate }}</span>
                    <button type="button" class="btn btn-sm btn-default" (click)="addJoinedTable()">
                        <app-icon icon="Add"></app-icon>
                    </button>
                 </div>

                 <!-- Joined Tables -->
                 <div class="joined-tables-wrapper">
                    @for (joinedTable of sectionJoinedTables; track joinedTable.tableId) {
                        <div class="joined-table-container d-flex flex-row align-content-center align-items-center">
                            <div class="joined-table d-flex flex-column p-2">
                                <input type="text" class="ihost-control disabled" name="joinedTableName"
                                    [ngModel]="joinedTable.tableName" disabled="disabled">
                                <div class="d-flex flex-row justify-content-between align-items-center">
                                    <div class="d-flex flex-column w-half">
                                        <label>Min</label>
                                        <input type="number" class="ihost-control" placeholder="Min" name="mincapacity" autocomplete="mincapacity"
                                            [ngModel]="joinedTable.minCapacity" (ngModelChange)="setJoinedTableMinCapacity(joinedTable, $event)">
                                    </div>
                                    <div class="d-flex flex-column w-half">
                                        <label>Max</label>
                                        <input type="number" class="ihost-control" placeholder="Max" name="maxcapacity" autocomplete="maxcapacity"
                                            [ngModel]="joinedTable.maxCapacity" (ngModelChange)="setJoinedTableMaxCapacity(joinedTable, $event)">
                                    </div>
                                </div>
                            </div>
                            <app-icon icon="Delete" color="#dc3545" (click)="showDeleteJoinedTableConfirmation(joinedTable)"></app-icon>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
}

<app-modal-dialog #deleteTableConfirmationModal title="{{ 'tablesPlan.editMode.deleteTableConfirmationTitle' | translate }}" modalId="confirmation-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="deleteTableWithTableAssignedCheck($event)">
    <div class="form-col">
        <p>{{ 'tablesPlan.editMode.deleteTableConfirmationMessage' | translate:{name: editingTable?.table?.tableName} }}</p>
    </div>
</app-modal-dialog>

<app-modal-dialog #deleteTableWithAssignedReservationConfirmationModal title="{{ 'tablesPlan.editMode.deleteTableConfirmationTitle' | translate }}" modalId="delete-table-confirmation-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="deleteTable($event)">
    <div class="form-col">
        <p>{{ 'tablesPlan.editMode.tableAssigned' | translate:{name: editingTable?.table?.tableName} }}</p>
    </div>
</app-modal-dialog>

<div #toast class="toast position-fixed bottom-0 start-50 translate-middle-x text-bg-danger z-2" role="alert" aria-live="assertive" aria-atomic="true"
    data-bs-config='{"delay":2500, "autohide": true, "animation": true}'>
    <div class="toast-body text-center">
      <p>{{validationMessage}}</p>
    </div>
</div>

<app-modal-dialog #deleteJoinTableOnRenameTableConfirmationModal title="{{ 'common.warning' | translate }}" modalId="delete-join-table-confirmation-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="saveEditingTable($event)">
    <div class="form-col">
        <p>{{ 'tablesPlan.editMode.deleteJoinTableOnRenameTable' | translate:{name: editingTable?.table?.tableName} }}</p>
    </div>
</app-modal-dialog>

<app-modal-dialog #deleteJoinedTableConfirmationModal title="{{ 'tablesPlan.editMode.deleteTableConfirmationTitle' | translate }}" modalId="delete-joined-table-confirmation-modal"
    okText="{{ 'common.buttons.continue' | translate }}" [isValid]="true" [hasCancel]="true"
    (onClose)="deleteJoinedTable($event)">
    <div class="form-col">
        <p>{{ 'tablesPlan.editMode.deleteJoinTableMsg' | translate }}</p>
    </div>
</app-modal-dialog>